
import {
  computed,
  defineComponent,
} from 'vue';

import ProductPost from '@/interfaces/ProductPost';
import Expansion from '@/components/Expansion.vue';
import ProductImage from '@/interfaces/ProductImage';

export default defineComponent({
  components: {
    Expansion,
  },

  props: {
    product: {
      required: false,
    },
    headline: {
      type: String,
      required: false,
      default: () => '0',
    },
    hovering: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    contentFirst: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },

  setup(props, context) {
    const {
      ioappConfig: {
        themeUri,
      },
    } = window;

    const content = context.slots.content ? context.slots.content() : null;
    const hasContent = computed(() => (
      content && content[0] ? `${content[0].children}`.trim().length > 0 : false
    ));

    const getSettingsLogoSrc = ($product: ProductPost): string => {
      let sourceUrl = '';
      if ($product.thumbnail) {
        sourceUrl = $product.thumbnail;
      }

      if (sourceUrl.length === 0 && $product.media) {
        let logoSource = $product.media.images.find((m: ProductImage) => m.key === 'logo');

        if (logoSource) {
          sourceUrl = `${logoSource.url || ''}`.trim();
        }

        if (sourceUrl.length === 0) {
          logoSource = $product.media.images.find((m: ProductImage) => m.isPreview);

          if (logoSource) {
            sourceUrl = `${logoSource.url || ''}`.trim();
          }
        }
      }

      return sourceUrl;
    };

    const hasLogoSrc = ($product: ProductPost): boolean => getSettingsLogoSrc($product).length > 0;

    const getLogoSrc = ($product: ProductPost) => {
      if (!hasLogoSrc($product)) {
        if ($product.branch === 'electricity') {
          return `${themeUri}/assets/img/swk-herne-logo-strom.svg`;
        }

        return `${themeUri}/assets/img/swk-herne-logo-gas.svg`;
      }

      return getSettingsLogoSrc($product);
    };

    const getProductName = ($product: ProductPost) => {
      if ($product.title.toLowerCase().startsWith('strom')) {
        return $product.title.substr(5).trim();
      } if ($product.title.toLowerCase().startsWith('gas')) {
        return $product.title.substr(4).trim();
      }

      return $product.title;
    };

    const contentExpanded = computed(() => {
      if (props.contentFirst) {
        return !props.hovering;
      }

      return props.hovering;
    });

    const benefitsExpanded = computed(() => {
      if (props.contentFirst) {
        return hasContent.value ? props.hovering : true;
      }

      return !props.hovering || !hasContent.value;
    });

    return {
      getLogoSrc,
      hasLogoSrc,
      getProductName,
      hasContent,
      contentExpanded,
      benefitsExpanded,
    };
  },
});
